import { createContext } from "react";

export type TabContexType = {
	hidden: boolean;
	setHidden: (hidden: boolean) => void;
};
export const TabContex = createContext<TabContexType | null>(null);
